import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppStateUnhealthy24 = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
			fill: "#E7EA2E",
			d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2z",
			transform: "translate(-516.000000, -594.000000) translate(503.000000, 564.000000) translate(13.000000, 30.000000)"
		}), /* @__PURE__ */ _jsx("path", {
			fill: "#000",
			d: "M12 15c.829 0 1.5.671 1.5 1.5S12.829 18 12 18s-1.5-.671-1.5-1.5.671-1.5 1.5-1.5zm0-8c.552 0 1 .448 1 1v5c0 .552-.448 1-1 1s-1-.448-1-1V8c0-.552.448-1 1-1z",
			transform: "translate(-516.000000, -594.000000) translate(503.000000, 564.000000) translate(13.000000, 30.000000)"
		})] }) }) })
	})]
});
const ForwardRef = forwardRef(SvgAppStateUnhealthy24);
export default ForwardRef;
